import { SelectOption } from '../SelectInput'

export function withHistoricalOption<T extends string>(
  options: SelectOption<T>[],
  currentValue: T | '' | undefined,
  historicalLabels: Record<string, string> = {}
): SelectOption<T>[] {
  if (!currentValue || options.some(option => option.value === currentValue)) {
    return options
  }

  return [
    ...options,
    {
      value: currentValue,
      label: historicalLabels[currentValue] || currentValue,
      disabled: true
    }
  ]
}
